import React from 'react';

const CtaBannerSection = () => {
  return (
    <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop mb-24 reveal-on-scroll">
      <div className="bg-gradient-to-r from-primary-container/10 to-transparent border border-primary/20 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8 backdrop-blur-md">
        <div className="flex items-center space-x-6">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <span className="material-symbols-outlined text-primary text-3xl">psychology_alt</span>
          </div>
          <div>
            <h3 className="font-headline-sm text-headline-sm mb-2">Don't See the EA You Need? <span className="text-primary">We'll Get It For You.</span></h3>
            <p className="text-on-surface-variant max-w-xl">Send us the MQL5 link of any Expert Advisor and we'll source it and list it at our discounted price—typically within 24 hours.</p>
          </div>
        </div>
        <button className="whitespace-nowrap bg-primary-container text-on-primary font-bold px-8 py-4 rounded-lg hover:scale-[1.02] transition-all btn-shimmer">Request an EA Now</button>
      </div>
    </div>
  );
};

export default CtaBannerSection;
